import adimg1 from "../../images/adimg1.jpg";
import { Link } from "react-router-dom";
import adimg from "../../images/adimg.png";
export const Adv = () => {
  return (
    <>
      <div className="avd-card adbox mob mb-4">
        <div className="imgbox">
          <span className="price">₹ 55 L - 1.50 L</span>
          <span className="ad">Ad</span>
          <img src={adimg1} className="img-ad-01 mt-0" alt="Advertisement" />
        </div>
        <div className="card-body d-flex justify-content-between">
          <div className="d-grid">
            <span className="avd-title">Alora</span>
            <span className="avd-title-text">Malviya Nagar</span>
          </div>
          <div className="d-flex" style={{ alignItems: "end" }}>
            <div className="avd-icon d-flex">
              <Link to="/">
                <div>
                  <svg
                    width="11"
                    height="11"
                    viewBox="0 0 11 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_3630_6618)">
                      <path
                        d="M4.95587 1.79672C5.51916 1.23344 6.28313 0.916992 7.07976 0.916992C8.73858 0.916992 10.0833 2.26175 10.0833 3.92059C10.0833 4.71719 9.76691 5.48117 9.20362 6.04445L8.02897 7.21908L7.21875 6.40885L8.3934 5.23422C8.74179 4.88583 8.9375 4.4133 8.9375 3.92059C8.9375 2.89457 8.10574 2.06283 7.07976 2.06283C6.58703 2.06283 6.1145 2.25855 5.7661 2.60695L4.59147 3.78158L3.78125 2.97135L4.95587 1.79672Z"
                        fill="#343434"
                      />
                      <path
                        d="M5.23373 8.3934L6.40836 7.21875L7.21859 8.02897L6.04396 9.20362C5.48068 9.76691 4.71671 10.0833 3.9201 10.0833C2.26126 10.0833 0.916504 8.73858 0.916504 7.07976C0.916504 6.28314 1.23295 5.51916 1.79623 4.95587L2.97086 3.78125L3.78109 4.59147L2.60646 5.7661C2.25806 6.1145 2.06234 6.58703 2.06234 7.07976C2.06234 8.10574 2.89409 8.9375 3.9201 8.9375C4.41281 8.9375 4.88534 8.74179 5.23373 8.3934Z"
                        fill="#343434"
                      />
                      <path
                        d="M4.18621 7.6237L7.6237 4.18621L6.81348 3.37598L3.37598 6.81348L4.18621 7.6237Z"
                        fill="#343434"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_3630_6618">
                        <rect width="11" height="11" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </Link>
              <Link to="/">
                <div>
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_1_31502)">
                      <path
                        d="M10.4693 9.36739C10.4693 9.53239 10.4327 9.70198 10.3547 9.86698C10.2768 10.032 10.176 10.1878 10.0431 10.3345C9.81849 10.582 9.57099 10.7607 9.29141 10.8753C9.01641 10.9899 8.71849 11.0495 8.39766 11.0495C7.93016 11.0495 7.43057 10.9395 6.90349 10.7149C6.37641 10.4903 5.84932 10.1878 5.32682 9.80739C4.79429 9.41786 4.29176 8.98887 3.82349 8.52406C3.36001 8.05748 2.93254 7.55647 2.54474 7.02531C2.16891 6.50281 1.86641 5.98031 1.64641 5.4624C1.42641 4.9399 1.31641 4.44031 1.31641 3.96365C1.31641 3.65198 1.37141 3.35406 1.48141 3.07906C1.59141 2.79948 1.76557 2.54281 2.00849 2.31365C2.30182 2.0249 2.62266 1.88281 2.96182 1.88281C3.09016 1.88281 3.21849 1.91031 3.33307 1.96531C3.45224 2.02031 3.55766 2.10281 3.64016 2.22198L4.70349 3.72073C4.78599 3.83531 4.84557 3.94073 4.88682 4.04156C4.92807 4.13781 4.95099 4.23406 4.95099 4.32115C4.95099 4.43115 4.91891 4.54115 4.85474 4.64656C4.79516 4.75198 4.70807 4.86198 4.59807 4.97198L4.24974 5.33406C4.19932 5.38448 4.17641 5.44406 4.17641 5.5174C4.17641 5.55406 4.18099 5.58615 4.19016 5.62281C4.20391 5.65948 4.21766 5.68698 4.22682 5.71448C4.30932 5.86573 4.45141 6.06281 4.65307 6.30115C4.85932 6.53948 5.07932 6.7824 5.31766 7.02531C5.56516 7.26823 5.80349 7.49281 6.04641 7.69906C6.28474 7.90073 6.48182 8.03823 6.63766 8.12073C6.66057 8.12989 6.68807 8.14364 6.72016 8.15739C6.75682 8.17114 6.79349 8.17573 6.83474 8.17573C6.91266 8.17573 6.97224 8.14823 7.02266 8.09781L7.37099 7.75406C7.48557 7.63948 7.59557 7.55239 7.70099 7.49739C7.80641 7.43323 7.91182 7.40114 8.02641 7.40114C8.11349 7.40114 8.20516 7.41948 8.30599 7.46073C8.40682 7.50198 8.51224 7.56156 8.62682 7.63948L10.1439 8.71656C10.2631 8.79906 10.3456 8.89531 10.396 9.00989C10.4418 9.12448 10.4693 9.23906 10.4693 9.36739Z"
                        stroke="#343434"
                        stroke-miterlimit="10"
                      />
                      <path
                        d="M8.87956 5.09115C8.87956 4.81615 8.66414 4.39448 8.34331 4.05073C8.04997 3.73448 7.66039 3.48698 7.27539 3.48698M10.4837 5.09115C10.4837 3.3174 9.04914 1.88281 7.27539 1.88281"
                        stroke="#343434"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1_31502">
                        <rect
                          width="11"
                          height="11"
                          fill="white"
                          transform="translate(0.400391 0.966797)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div
        id="gitSampleCarousel2"
        className="carousel slide mob"
        data-bs-ride="carousel"
      >
        <div className="carousel-inner">
          <div className="carousel-item active">
            <div className="row g-2">
              <div className="col-md-6 col-6">
                <div className="avd-card adverorng orngbg">
                  <div className="ad-gsc2-mask-container">
                    <img src={adimg} className="target-image" alt="..." />
                    <span className="ad-badge">Ad</span>
                  </div>
                  <div className="card-body">
                    <h6 className="card-title ad-slider-text">Samanvay</h6>
                    <p className="avd-title-text-2 m-0">Mansarovar</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-6">
                <div className="avd-card adverorng orngbg">
                  <div className="ad-gsc2-mask-container">
                    <img src={adimg} className="target-image" alt="..." />
                    <span className="ad-badge">Ad</span>
                  </div>
                  <div className="card-body">
                    <h6 className="card-title ad-slider-text">Trimurty</h6>
                    <p className="avd-title-text-2 m-0">Mansarovar</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="carousel-item">
            <div className="row g-2">
              <div className="col-md-6 col-6">
                <div className="avd-card orngbg">
                  <div className="ad-gsc2-mask-container">
                    <img src={adimg} className="target-image" alt="..." />
                    <span className="ad-badge">Ad</span>
                  </div>
                  <div className="card-body">
                    <h6 className="card-title ad-slider-text">Manglam</h6>
                    <p className="avd-title-text-2 m-0">Mansarovar</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-6">
                <div className="avd-card orngbg">
                  <div className="ad-gsc2-mask-container">
                    <img src={adimg} className="target-image" alt="..." />
                    <span className="ad-badge">Ad</span>
                  </div>
                  <div className="card-body">
                    <h6 className="card-title ad-slider-text">Narayana</h6>
                    <p className="avd-title-text-2 m-0">Mansarovar</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button
          className="custom-btn custom-btn-prev"
          type="button"
          data-bs-target="#gitSampleCarousel2"
          data-bs-slide="prev"
        >
          <span>&lt;</span>
        </button>
        <button
          className="custom-btn custom-btn-next"
          type="button"
          data-bs-target="#gitSampleCarousel2"
          data-bs-slide="next"
        >
          <span>&gt;</span>
        </button>
      </div>
    </>
  );
};
